[
  { "date": "2023-12-25", "holidayName": "Første juledag" },
  { "date": "2023-12-26", "holidayName": "Andre juledag" },
  { "date": "2024-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2024-03-28", "holidayName": "Skjærtorsdag" },
  { "date": "2024-03-29", "holidayName": "Langfredag" },
  { "date": "2024-03-31", "holidayName": "Første påskedag" },
  { "date": "2024-04-01", "holidayName": "Andre påskedag" },
  { "date": "2024-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2024-05-09", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2024-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2024-05-19", "holidayName": "Første pinsedag" },
  { "date": "2024-05-20", "holidayName": "Andre pinsedag" },
  { "date": "2024-12-25", "holidayName": "Første juledag" },
  { "date": "2024-12-26", "holidayName": "Andre juledag" },
  { "date": "2025-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2025-04-17", "holidayName": "Skjærtorsdag" },
  { "date": "2025-04-18", "holidayName": "Langfredag" },
  { "date": "2025-04-20", "holidayName": "Første påskedag" },
  { "date": "2025-04-21", "holidayName": "Andre påskedag" },
  { "date": "2025-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2025-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2025-05-29", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2025-06-08", "holidayName": "Første pinsedag" },
  { "date": "2025-06-09", "holidayName": "Andre pinsedag" },
  { "date": "2025-12-25", "holidayName": "Første juledag" },
  { "date": "2025-12-26", "holidayName": "Andre juledag" },
  { "date": "2026-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2026-04-02", "holidayName": "Skjærtorsdag" },
  { "date": "2026-04-03", "holidayName": "Langfredag" },
  { "date": "2026-04-05", "holidayName": "Første påskedag" },
  { "date": "2026-04-06", "holidayName": "Andre påskedag" },
  { "date": "2026-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2026-05-14", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2026-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2026-05-24", "holidayName": "Første pinsedag" },
  { "date": "2026-05-25", "holidayName": "Andre pinsedag" },
  { "date": "2026-12-25", "holidayName": "Første juledag" },
  { "date": "2026-12-26", "holidayName": "Andre juledag" },
  { "date": "2027-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2027-03-25", "holidayName": "Skjærtorsdag" },
  { "date": "2027-03-26", "holidayName": "Langfredag" },
  { "date": "2027-03-28", "holidayName": "Første påskedag" },
  { "date": "2027-03-29", "holidayName": "Andre påskedag" },
  { "date": "2027-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2027-05-06", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2027-05-16", "holidayName": "Første pinsedag" },
  { "date": "2027-05-17", "holidayName": "Andre pinsedag, Grunnlovsdag" },
  { "date": "2027-12-25", "holidayName": "Første juledag" },
  { "date": "2027-12-26", "holidayName": "Andre juledag" },
  { "date": "2028-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2028-04-13", "holidayName": "Skjærtorsdag" },
  { "date": "2028-04-14", "holidayName": "Langfredag" },
  { "date": "2028-04-16", "holidayName": "Første påskedag" },
  { "date": "2028-04-17", "holidayName": "Andre påskedag" },
  { "date": "2028-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2028-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2028-05-25", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2028-06-04", "holidayName": "Første pinsedag" },
  { "date": "2028-06-05", "holidayName": "Andre pinsedag" },
  { "date": "2028-12-25", "holidayName": "Første juledag" },
  { "date": "2028-12-26", "holidayName": "Andre juledag" },
  { "date": "2029-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2029-03-29", "holidayName": "Skjærtorsdag" },
  { "date": "2029-03-30", "holidayName": "Langfredag" },
  { "date": "2029-04-01", "holidayName": "Første påskedag" },
  { "date": "2029-04-02", "holidayName": "Andre påskedag" },
  { "date": "2029-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2029-05-10", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2029-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2029-05-20", "holidayName": "Første pinsedag" },
  { "date": "2029-05-21", "holidayName": "Andre pinsedag" },
  { "date": "2029-12-25", "holidayName": "Første juledag" },
  { "date": "2029-12-26", "holidayName": "Andre juledag" },
  { "date": "2030-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2030-04-18", "holidayName": "Skjærtorsdag" },
  { "date": "2030-04-19", "holidayName": "Langfredag" },
  { "date": "2030-04-21", "holidayName": "Første påskedag" },
  { "date": "2030-04-22", "holidayName": "Andre påskedag" },
  { "date": "2030-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2030-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2030-05-30", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2030-06-09", "holidayName": "Første pinsedag" },
  { "date": "2030-06-10", "holidayName": "Andre pinsedag" },
  { "date": "2030-12-25", "holidayName": "Første juledag" },
  { "date": "2030-12-26", "holidayName": "Andre juledag" },
  { "date": "2031-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2031-04-10", "holidayName": "Skjærtorsdag" },
  { "date": "2031-04-11", "holidayName": "Langfredag" },
  { "date": "2031-04-13", "holidayName": "Første påskedag" },
  { "date": "2031-04-14", "holidayName": "Andre påskedag" },
  { "date": "2031-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2031-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2031-05-22", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2031-06-01", "holidayName": "Første pinsedag" },
  { "date": "2031-06-02", "holidayName": "Andre pinsedag" },
  { "date": "2031-12-25", "holidayName": "Første juledag" },
  { "date": "2031-12-26", "holidayName": "Andre juledag" },
  { "date": "2032-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2032-03-25", "holidayName": "Skjærtorsdag" },
  { "date": "2032-03-26", "holidayName": "Langfredag" },
  { "date": "2032-03-28", "holidayName": "Første påskedag" },
  { "date": "2032-03-29", "holidayName": "Andre påskedag" },
  { "date": "2032-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2032-05-06", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2032-05-16", "holidayName": "Første pinsedag" },
  { "date": "2032-05-17", "holidayName": "Andre pinsedag, Grunnlovsdag" },
  { "date": "2032-12-25", "holidayName": "Første juledag" },
  { "date": "2032-12-26", "holidayName": "Andre juledag" },
  { "date": "2033-01-01", "holidayName": "Første nyttårsdag" },
  { "date": "2033-04-14", "holidayName": "Skjærtorsdag" },
  { "date": "2033-04-15", "holidayName": "Langfredag" },
  { "date": "2033-04-17", "holidayName": "Første påskedag" },
  { "date": "2033-04-18", "holidayName": "Andre påskedag" },
  { "date": "2033-05-01", "holidayName": "Arbeidernes dag" },
  { "date": "2033-05-17", "holidayName": "Grunnlovsdag" },
  { "date": "2033-05-26", "holidayName": "Kristi himmelfartsdag" },
  { "date": "2033-06-05", "holidayName": "Første pinsedag" },
  { "date": "2033-06-06", "holidayName": "Andre pinsedag" }
]
